exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#share-network-list {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    max-width: 1000px;\n    margin: auto;\n}\na[class^=\"share-network-\"] {\n    flex: none;\n    color: #FFFFFF;\n    background-color: #333;\n    border-radius: 3px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: row;\n    align-content: center;\n    align-items: center;\n    cursor: pointer;\n    margin: 0 10px 10px 0;\n}\na[class^=\"share-network-\"] span {\n    padding: 0 10px;\n    flex: 1 1;\n    font-weight: 500;\n}\na[class^=\"share-network-\"] .fah {\n    background-color: rgba(0, 0, 0, 0.2);\n    padding: 10px;\n    flex: 0 1 auto;\n}\n.fab, .far {\n    font-weight: 400;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1de8a71b","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/shareSmall.vue
// module id = tFLr
// module chunks = 0